module.exports = __webpack_public_path__ + "static/img/11.d25a262.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/11.png
// module id = 4zPr
// module chunks = 0